// extracted by mini-css-extract-plugin
export default {"callout":"text-callout_callout__Jc7Zf","calloutTitle":"text-callout_calloutTitle__tpszZ","calloutContent":"text-callout_calloutContent__2opU3"};